import { FC } from 'react'

import * as S from './styled'
import { ClosureShape, LeroyIcon, UserPlusIcons } from '../../icons'

const Closure: FC = () => (
  <S.Container>
    <S.Wrapper>
      <S.Content>
        <S.Title>
          <span>08</span> Encerramento
        </S.Title>

        <S.Subtitle>
          <LeroyIcon />

          <h3>Pela Leroy Merlin</h3>
        </S.Subtitle>

        <S.Row>
          <S.Column1>
            <h4>Encerramento motivado</h4>

            <p>
              A LEROY MERLIN poderá recusar, suspender ou cancelar a conta de
              Participante no Programa de Fidelidade, sempre que:
            </p>
          </S.Column1>

          <S.Column2>
            <ul>
              <li>
                suspeitar que as informações fornecidas são falsas, incompletas,
                <br />
                desatualizadas ou imprecisas;
              </li>
              <li>
                suspeitar de abusos, fraudes e/ou violação deste regulamento e;
              </li>
              <li>
                nos casos indicados em leis e regulamentos aplicáveis, este
                documento e<br />
                nas Políticas relacionadas
              </li>
            </ul>
          </S.Column2>
        </S.Row>
        <S.Row2>
          <S.Column1>
            <h4>Unilateral</h4>

            <p>
              A LEROY MERLIN poderá de forma unilateral e a qualquer momento, o
              Programa de Fidelidade.
            </p>
          </S.Column1>

          <S.Column2>
            <p>
              Os Participantes serão comunicados pelos principais canais de
              comunicação, com antecedência mínima de{' '}
              <strong>60 (sessenta) dias e poderão</strong> usar todos os
              benefícios oferecidos, por no{' '}
              <strong>máximo 30 (trinta) dias</strong>.
            </p>
          </S.Column2>
        </S.Row2>

        <S.Subtitle>
          <UserPlusIcons />
          <h3>Pelo Participante</h3>
        </S.Subtitle>

        <S.Row>
          <S.Column>
            <p>
              É possível cancelar a participação do programa por meio do CALM,
              com exceção do segmento Executor/ PRO,
              <br />
              mediante solicitação nas lojas físicas. O cancelamento e a
              suspensão resultam na perda de todos os benefícios.
            </p>
          </S.Column>
        </S.Row>

        <S.Bg>
          <ClosureShape />
        </S.Bg>
      </S.Content>
    </S.Wrapper>
  </S.Container>
)

export default Closure
